var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleteButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 72,
    viewBox: "0 0 138 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 136,
    height: 70,
    rx: 35,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 136,
    height: 70,
    rx: 35,
    stroke: "#7B79A2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9922 20.0781C51.0703 20.0781 54.625 22.8125 54.625 26.9531C54.625 30.5273 51.8125 33.125 47.6328 33.6328V37.0312C50.875 36.8945 54.1758 36.6016 57.2031 36.1328L57.4375 38.4375C50.0938 39.7656 41.7734 39.8438 35.7578 39.8438L35.3672 37.3047C38.0625 37.3242 41.2266 37.3047 44.5469 37.1875V33.6719C40.25 33.2031 37.3594 30.5859 37.3984 26.9531C37.3594 22.8125 40.9141 20.0781 45.9922 20.0781ZM45.9922 22.4609C42.6328 22.4609 40.25 24.2578 40.2891 26.9531C40.25 29.5703 42.6328 31.3672 45.9922 31.4062C49.3906 31.3672 51.6953 29.5703 51.7344 26.9531C51.6953 24.2578 49.3906 22.4609 45.9922 22.4609ZM62.5156 18.4766V30.2344H67.7109V32.8516H62.5156V45.0391H59.4297V18.4766H62.5156ZM63.7656 49.8047V52.3828H40.4453V42.7344H43.5312V49.8047H63.7656ZM101.773 46.2891V48.8672H69.9766V46.2891H78.9219V39.6875H73.9609V28.9844H94.7422V23.5547H73.8828V21.0156H97.75V31.5234H77.0078V37.1484H98.5703V39.6875H93.1406V46.2891H101.773ZM81.9297 46.2891H90.1328V39.6875H81.9297V46.2891Z",
    fill: "#7B79A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteButton);
export default __webpack_public_path__ + "static/media/CompleteButton.130ce4b357228f843abe0b5d68db0819.svg";
export { ForwardRef as ReactComponent };